import * as React from "react";
import {LockUnlockReasons} from "../MassiveActionsTypesAndFunctions";
import {DATA_STATE} from "../../../users/contexts/UsersDashboardContext";
import {getLockUnlockReasons} from "../MassiveActionsController";

interface LockUnlockEquipmentCompressorContextType {
    lockUnlockReasons: {
        reasons: LockUnlockReasons;
        reasonsState: DATA_STATE
    }
}

export const LockUnlockEquipmentCompressorContext = React.createContext<LockUnlockEquipmentCompressorContextType>(
    {} as any);

export const LockUnlockEquipmentCompressorProvider: React.FC = ({children}) => {
    const [reasons, setReasons] = React.useState<LockUnlockReasons>()
    const [reasonsState, setReasonsState] = React.useState<DATA_STATE>(DATA_STATE.isLoading)


    React.useEffect(() => {
        getLockUnlockReasons()
            .then(lists => setReasons(lists))
            .then(() => setReasonsState(DATA_STATE.loaded))
            .catch(error => setReasonsState(DATA_STATE.error))
    }, [])

    return (
        <LockUnlockEquipmentCompressorContext.Provider
            value={{
                lockUnlockReasons: {reasons, reasonsState}
            }}
        >
            {children}
        </LockUnlockEquipmentCompressorContext.Provider>
    );
}

